import { LOGOUT, SET_CURRENT_EXTERNAL_UNIT, SET_EXTERNAL_UNITS_LIST } from "../actions/types";

const INITIAL_STATE = {
    current: {
        externalOuID: null,
        name: null,
        active: null,
        coordinatorID: null,
        coordinatorEmail: null,
        coordinatorFname: null,
        coordinatorLname: null,
        employees: []
    },
    list: []
};

const externalUnitReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case SET_CURRENT_EXTERNAL_UNIT:
            return {
                ...state,
                current: {
                    externalOuID: action.payload.externalOuID,
                    name: action.payload.name,
                    active: action.payload.active,
                    coordinatorID: action.payload.coordinatorID,
                    coordinatorEmail: action.payload.coordinatorEmail,
                    coordinatorFname: action.payload.coordinatorFname,
                    coordinatorLname: action.payload.coordinatorLname,
                    employees: action.payload.employees.map(employee => {
                        return {
                            userID: employee.userID,
                            email: employee.email,
                            fname: employee.fname,
                            lname: employee.lname
                        };
                    })
                }
            };
        case SET_EXTERNAL_UNITS_LIST:
            return {
                ...state,
                list: action.payload.map(unit => {
                    return {
                        externalOuID: unit.externalOuID,
                        name: unit.name,
                        active: unit.active
                    };
                })
            };
        case LOGOUT:
            return INITIAL_STATE;
        default:
            return state;
    }
};

export default externalUnitReducer;